"use client";

import { Hero } from "./hero";
import { ExecutiveSummary } from "./executive-summary";
import { OrgStructure } from "./org-structure";
import { Philosophy } from "./philosophy";
import { ExecutiveTeam } from "./executive-team";
import { EngineeringLeadership } from "./engineering-leadership";
import { StrategicLeadership } from "./strategic-leadership";
import { OperationalLeadership } from "./operational-leadership";
import { ResearchLeadership } from "./research-leadership";
import { ValuesInAction } from "./values-in-action";
import { Governance } from "./governance";
import { LeadershipCommitment } from "./leadership-commitment";
import { IndustryExperience } from "./industry-experience";
import { TeamCulture } from "./team-culture";
import { ClientRelationships } from "./client-relationships";
import { ForwardVision } from "./forward-vision";
import { EthicalLeadership } from "./ethical-leadership";
import { LeadershipAvailability } from "./leadership-availability";
import { Accountability } from "./accountability";
import { GetInTouch } from "./get-in-touch";

export function LeadershipPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-purple">
        <ExecutiveSummary />
      </div>
      <OrgStructure />
      <div className="bg-aurora-cyan">
        <Philosophy />
      </div>
      <ExecutiveTeam />
      <div className="bg-aurora-emerald">
        <EngineeringLeadership />
      </div>
      <StrategicLeadership />
      <div className="bg-aurora-amber">
        <OperationalLeadership />
      </div>
      <ResearchLeadership />
      <div className="bg-aurora-purple">
        <ValuesInAction />
      </div>
      <Governance />
      <div className="bg-aurora-cyan">
        <LeadershipCommitment />
      </div>
      <IndustryExperience />
      <div className="bg-aurora-emerald">
        <TeamCulture />
      </div>
      <ClientRelationships />
      <div className="bg-aurora-amber">
        <ForwardVision />
      </div>
      <EthicalLeadership />
      <div className="bg-aurora-purple">
        <LeadershipAvailability />
      </div>
      <Accountability />
      <GetInTouch />
    </>
  );
}
